<div>
    <div class="row">
        <div class="col-xs-12">
            <div class="panel panel-default table-no-borders table-spacer">
                <div class="panel-heading-title">Filter Business Rules</div>

                <div class="panel-body no-padding pdl15">
                    <div class="col-lg-3 checkbox-inline">
                        <i
                            id="pass"
                            ng-click="validationResultsController.includePass = !validationResultsController.includePass"
                            ng-change="validationResultsController.paginationCallback()"
                            class="nlrp-icon"
                            [ngClass]="{'nlrp-icon-check-box-selected': includePass, 'nlrp-icon-check-box-unselected': !includePass, 'active':  includePass}"
                            (click)="onChangeBusinessRuleFilter($event)"
                            ng-model="validationResultsController.includePass"
                            tabindex="0"
                            title="Show/hide pass validation results"></i>
                        <span
                            ng-click="validationResultsController.includePass = !validationResultsController.includePass"
                            (click)="onChangeBusinessRuleFilter($event)"
                            tabindex="0"
                            >Pass</span
                        >
                    </div>

                    <div class="col-lg-3 checkbox-inline">
                        <i
                            id="info"
                            ng-click="validationResultsController.includeInfo = !validationResultsController.includeInfo"
                            ng-change="validationResultsController.paginationCallback()"
                            class="nlrp-icon info"
                            [ngClass]="{'nlrp-icon-check-box-selected': includeInfo, 'nlrp-icon-check-box-unselected': !includeInfo, 'active':  includeInfo}"
                            (click)="onChangeBusinessRuleFilter($event)"
                            ng-model="validationResultsController.includeInfo"
                            tabindex="0"
                            title="Show/hide info validation results"></i>
                        <span
                            ng-click="validationResultsController.includeInfo = !validationResultsController.includeInfo"
                            (click)="onChangeBusinessRuleFilter($event)"
                            tabindex="0"
                            >Info</span
                        >
                    </div>

                    <div class="col-lg-3 checkbox-inline">
                        <i
                            id="warning"
                            ng-click="validationResultsController.includeWarning = !validationResultsController.includeWarning"
                            ng-change="validationResultsController.paginationCallback()"
                            class="nlrp-icon warning"
                            [ngClass]="{'nlrp-icon-check-box-selected': includeWarning, 'nlrp-icon-check-box-unselected': !includeWarning, 'active':  includeWarning}"
                            (click)="onChangeBusinessRuleFilter($event)"
                            ng-model="validationResultsController.includeWarning"
                            tabindex="0"
                            title="Show/hide warning validation results"></i>
                        <span
                            ng-click="validationResultsController.includeWarning = !validationResultsController.includeWarning"
                            (click)="onChangeBusinessRuleFilter($event)"
                            tabindex="0"
                            >Warning</span
                        >
                    </div>

                    <div class="col-lg-3 checkbox-inline">
                        <i
                            id="error"
                            ng-click="validationResultsController.includeError = !validationResultsController.includeError"
                            ng-change="validationResultsController.paginationCallback()"
                            class="nlrp-icon error"
                            [ngClass]="{'nlrp-icon-check-box-selected': includeError, 'nlrp-icon-check-box-unselected': !includeError, 'active':  includeError}"
                            (click)="onChangeBusinessRuleFilter($event)"
                            ng-model="validationResultsController.includeError"
                            tabindex="0"
                            title="Show/hide error validation results"></i>
                        <span
                            ng-click="validationResultsController.includeError = !validationResultsController.includeError"
                            (click)="onChangeBusinessRuleFilter($event)"
                            tabindex="0"
                            >Error</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="view-report">
        <ul class="nav nav-pills results">
            <li
                [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_INFORMATION)}"
                title="View the information screen validation results">
                <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_INFORMATION)">
                    Information
                    <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_INFORMATION)}}</div>
                </a>
            </li>
            @if (isAnalysisTabEnabled) {
                <li
                    [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_ANALYSIS)}"
                    title="View the analysis screen validation results">
                    <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_ANALYSIS)">
                        Analysis
                        <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_ANALYSIS)}}</div>
                    </a>
                </li>
            }
            @if (isInterestsTabEnabled) {
                <li
                    [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_INTERESTS)}"
                    title="View the interests screen validation results">
                    <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_INTERESTS)">
                        Interests
                        <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_INTERESTS)}}</div>
                    </a>
                </li>
            }
            @if (isDesignTabEnabled) {
                <li
                    [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_DESIGN)}"
                    title="View the design screen validation results">
                    <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_DESIGN)">
                        Design
                        <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_DESIGN)}}</div>
                    </a>
                </li>
            }
            @if (isCertificationTabEnabled) {
                <li
                    [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_CERTIFICATION)}"
                    title="View the certification screen validation results">
                    <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_CERTIFICATION)">
                        Certification
                        <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_CERTIFICATION)}}</div>
                    </a>
                </li>
            }
            <li
                [ngClass]="{active:isTabSelected(PLAN_VALIDATION_STAGE.LODGEMENT_LODGE)}"
                title="View the lodge screen validation results">
                <a (click)="selectTab(PLAN_VALIDATION_STAGE.LODGEMENT_LODGE)">
                    Lodge
                    <div class="badge">{{getTotalResultsByStage(PLAN_VALIDATION_STAGE.LODGEMENT_LODGE)}}</div>
                </a>
            </li>
        </ul>
    </div>

    <div class="panel panel-default table-no-borders">
        <table class="table">
            <thead>
                <tr class="default">
                    <td class="col-md-1">Result</td>
                    <td class="col-md-1"></td>
                    <td class="col-md-10">Rule execution result message</td>
                </tr>
            </thead>

            <tbody>
                @for (r of pagenatedResults; track r) {
                    <tr>
                        <td class="result-type-text">
                            @if (r.type === RULE_OUTCOME.PASS) {
                                <span>Pass</span>
                            }
                            @if (r.type === RULE_OUTCOME.ERROR) {
                                <span>Error</span>
                            }
                            @if (r.type === RULE_OUTCOME.CRITICAL) {
                                <span>Error</span>
                            }
                            @if (r.type === RULE_OUTCOME.WARNING) {
                                <span>Warning</span>
                            }
                            @if (r.type === RULE_OUTCOME.INFO) {
                                <span>Info</span>
                            }
                        </td>
                        <td class="result-type-icon">
                            <i
                                class="nlrp-icon active"
                                [ngClass]="getValidationResultIcon(r.type)">
                            </i>
                        </td>
                        <td
                            class="alias-selector"
                            data-container="body"
                            [nlrTooltip]="formatDetailsToolTip(r.details)"
                            [nlrTooltipPosition]="'top'">
                            <span>{{r.ruleMessage}}</span>
                        </td>
                    </tr>
                }
                @if (!resultExists()) {
                    <tr>
                        <td colspan="4">No records found.</td>
                    </tr>
                }
            </tbody>
        </table>

        <div>
            <div class="col-xs-7 view-report">
                <button
                    type="button"
                    id="exportValidationReportBtn"
                    class="btn btn-default nlr-btn-sm"
                    [disabled]="validationResults === undefined || validationResults.length === 0 || this.isExportReportBtnDisabled"
                    ng-click="validationResultsController.generateValidationsReport()"
                    (click)="generateValidationsReport()">
                    View report
                    <i
                        class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                        style="display: none;"></i>
                </button>
            </div>
            <div class="col-xs-5 pagination-footer">
                @if (total > pageSize) {
                    <nlr-pagination
                        class="pull-right"
                        [currentPage]="currentPage"
                        [pageSize]="pageSize"
                        [collectionSize]="total"
                        (pageChange)="paginatedValidationResultsData($event)"></nlr-pagination>
                }
                @if (total > 0) {
                    <span class="pull-right"> Showing {{start}} to {{end}} of {{total}} </span>
                }
            </div>
        </div>
    </div>
</div>
